(function() {
    'use strict';

    angular.module( APP_ID )
        .controller( 'GenericSubpageController', [ '$scope', 'SubpagesService', 'LoggerFactory', 'ContentSwitchingService', 'MetaService', 'Utils', 'TEXTS', 'CONFIG', GenericSubpageController ]);

    /**
     * Controller for generic subpage in the Areas, Degrees or Postgrads pages.
     *
     * @param {ng.IScope} $scope
     * @param {SubpagesService} SubpagesService
     * @param {LoggerFactory} LoggerFactory
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {MetaService} MetaService
     * @param {Utils} Utils
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function GenericSubpageController(
    	$scope,
        SubpagesService,
        LoggerFactory,
        ContentSwitchingService,
        MetaService,
        Utils,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {string} */
        var subpageId = undefined;


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'GenericSubpageController' );






        /* ===== EXPOSE TO THE SCOPE ======================================== */


        /** @const */
        $scope._        = TEXTS;
        $scope.CONFIG   = CONFIG;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        function init(){
            var currentSubpageInfo = SubpagesService.getCurrentSubpageInfo(), popped = false;

            subpageId = currentSubpageInfo.contentId;

            /* Watchers. */
            $scope.$watch( '$parent.vm.content.' + subpageId, function( newContentBlocks ){
                if ( newContentBlocks ) {
                    bindContentToSubpage();
                }
            });

            // remove then push the subpageid
            MetaService.searchAttributes.forEach (function removeSubPageId(searchItem, index){
                if (searchItem['name'] == 'subpage-id'){
                    MetaService.searchAttributes.splice(index,1);
                    MetaService.searchAttributes.push({
                        name:  'subpage-id',
                        value: currentSubpageInfo.id,
                    });
                    popped = true;
                }
            });
            if (!popped){
                MetaService.searchAttributes.push({
                    name:  'subpage-id',
                    value: currentSubpageInfo.id,
                });
            }

            MetaService.updateTitleStructure({
                subpage: currentSubpageInfo.meta.title
            });

            MetaService.updateDescriptionStructure({
                subpage: currentSubpageInfo.meta.description
            });

            setWatchers();
        };

        /** Run right after all the bindings are ready! */
        vm.$onInit = init;





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function setWatchers() {
            $scope.$watch( 'ContentSwitchingService.contentType', function() {
                vm.isInternationalContent = ContentSwitchingService.isInternational();
            });
        }


        /**
         * Binds content to the Controller's ViewModel based on what
         * subpage is currently selected.
         */
        function bindContentToSubpage() {
            if ( $scope.$parent.vm.content.hasOwnProperty( subpageId ) ) {
                vm.dynamicContentSettings = $scope.$parent.vm.dynamicBlocksSettings;
                vm.dynamicContentBlocks   = $scope.$parent.vm.content[ subpageId ];

                vm.dynamicContentSettings.contentBlocks = vm.dynamicContentBlocks;
            } else {
                logger.error( "The attribute `%s` does not exist in parent's content object and so dynamic content cannot be rendered...", subpageId, $scope.$parent.vm.content );
            }


            var currentSubpage = SubpagesService.getCurrentSubpageInfo();

            // If `Degrees - Overview` subpage, render extra dynamic block - 'abstract'
            if ( currentSubpage === SubpagesService.getSubpageInfoByStateId( CONFIG.STATES.DEGREES.ABOUT ) ) vm.abstract = Utils.getSharedContent().abstract;

            // If `Degrees - Requirements` subpage, render a list with in-page anchors
            if ( currentSubpage === SubpagesService.getSubpageInfoByStateId( CONFIG.STATES.DEGREES.REQUIREMENTS ) ) vm.showAnchorsList = true;
        }
    }
})();
